const initialState = {
     all_sms_template: [],
}

const smsTemplateReducer = (state = initialState, action) => {
    switch (action.type) {        
        case 'GET_SMS_TEMPLATE_SUCCESS':
            return {
                ...state,
                all_sms_template: action.payload || [],
            };            
        case 'DELETE_SMS_TEMPLATE_SUCCESS':
            return {
                ...state,
                all_sms_template: action.payload || [],
            };
        case 'SEARCH_SMS_TEMPLATE_SUCCESS':
            return {
                ...state,
                all_sms_template: action.payload || [],
            };            
        case 'GET_TEMPLATE_FAILURE':
            return { ...state, error: action.payload };
        default:
            return state;
    }
}

export default smsTemplateReducer;